export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_5uUWzhOsv',
      userPoolClientId: '753tlpol4jnqbiefs5cr5njlju',
      region: 'us-east-1',
    }
  }
};
